import ApiService from '@/utils/api.service'
import { AUTH_LOGOUT, AUTH_REQUEST, AUTH_SUCCESS, CHECK_AUTH, WEBAUTHN_REQUEST } from '../actions/auth'
import { CLIENT_APP } from '@/utils/config'
import qs from 'qs'
import JwtService from '@/utils/jwt.service'
import { API_URL } from '@/utils/config'
import { startAuthentication } from '@simplewebauthn/browser';


export default {
  state: {
    user: {},
    accessToken: JwtService.getToken() || '',
    refreshToken: JwtService.getRefreshToken() || ''
  },

  getters: {
    isAuthenticated: state => !!state.accessToken
  },

  actions: {
    [AUTH_REQUEST]: ({ commit, dispatch }, credentials) => {
      return new Promise((resolve, reject) => {
        ApiService
          .post(`auth/oauth2/token?grant_type=password&client_id=${CLIENT_APP}`, qs.stringify(credentials), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          .then(resp => {
            JwtService.saveToken(resp.data.access_token, resp.data.refresh_token)
            ApiService.setHeader()
            commit(AUTH_SUCCESS, resp.data)
            resolve(resp)
          })
          .catch(err => {
            commit('auth/' + AUTH_LOGOUT, err, { root: true })
            reject(err)
          })
      })
    },
    [WEBAUTHN_REQUEST]: ({ commit, dispatch }, credentials) => {
      return new Promise((resolve, reject) => {
        const handleError = err => {
            console.error(err) // DEBUG ONLY --- REMOVE BEFORE FLIGHT
            commit('auth/' + AUTH_LOGOUT, err, { root: true })
            reject(err)
          }
      
        // console.log("Authenticate with usename", credentials.username)
        
        ApiService.get(`api/v1/auth/authenticate/start?`+qs.stringify({username:credentials.username})).then(
          optionsData => {
            const optionsJSON = optionsData.data

            // console.log(optionsJSON)
            
            try {
                // Pass the options to the authenticator and wait for a response
                startAuthentication({ optionsJSON }).then(
                  asseResp => {
                    // POST the response to the endpoint that calls
                    // @simplewebauthn/server -> verifyAuthenticationResponse()
                    ApiService.post(`api/v1/auth/authenticate`, JSON.stringify(asseResp), {
                        headers:{
                            "Content-Type": 'application/json',
                        }}
                    ).then(
                      verificationResp => {
                        // Wait for the results of verification
                        const verificationJSON = verificationResp.data;

                        // Show UI appropriate for the `verified` status
                        if (verificationJSON && verificationJSON.access_token) {
                            // authenticationStatus.value = `Success! New Token : ${verificationJSON.access_token}`;
                            JwtService.saveToken(verificationJSON.access_token, verificationJSON.refresh_token)
                            ApiService.setHeader()
                            commit(AUTH_SUCCESS, verificationJSON)
                            resolve(verificationJSON)
                            // emit('authenticated', verificationJSON)
                        } else {
                            // authenticationStatus.value = `Oh no, something went wrong! Response: <pre>${JSON.stringify(
                            //     verificationJSON,
                            // )}</pre>`;
                            commit('auth/' + AUTH_LOGOUT, err, { root: true })
                            reject(verificationJSON)
                        }
                      },
                      handleError
                    )
                  },
                  handleError
                )
            } catch (error) {
                // Some basic error handling
                // authenticationStatus.value = error;
                // throw error;
                handleError(error)
            }
          },
          handleError
        )
      })
    },
    [AUTH_LOGOUT]: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_LOGOUT)
        resolve()
      })
    },
    [CHECK_AUTH] ({ commit, state }) {
      if (!state.refreshToken) {
        commit(AUTH_LOGOUT)
        return Promise.reject(new Error('no_token'))
      }
      return ApiService
        .post('auth/oauth2/token', qs.stringify({
          grant_type: 'refresh_token',
          client_id: CLIENT_APP,
          refresh_token: state.refreshToken
        }))
        .then(resp => {
          JwtService.saveToken(resp.data.access_token, resp.data.refresh_token)
          ApiService.setHeader()
          commit(AUTH_SUCCESS, resp.data)
          return resp
        })
        .catch(err => {
          // Only the server refusing the grant proves the refresh token is dead. A
          // network failure — a laptop waking up before the wifi is back — leaves it
          // perfectly usable, and discarding the credentials there logs the user out
          // for nothing.
          const status = err.response ? err.response.status : null
          if (status === 400 || status === 401) {
            commit(AUTH_LOGOUT)
          }
          return Promise.reject(err)
        })
    }
  },

  mutations: {
    [AUTH_SUCCESS] (state, data) {
      state.refreshToken = data.refresh_token
      state.accessToken = data.access_token
    },
    [AUTH_LOGOUT] (state) {
      JwtService.destroyToken()
      ApiService.removeHeader()
      state.refreshToken = null
      state.accessToken = null
    }
  }
}
